module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container product-list"
  }, [_c('h1', {
    staticClass: "header-title"
  }, [_vm._v("รายการ")]), _vm._v(" "), (_vm.ready) ? _c('div', [_c('div', {
    staticClass: "product-list-item-wrapper row flex"
  }, _vm._l((_vm.products), function(productId) {
    return _c('div', {
      staticClass: "col-sm-4 flex"
    }, [_c('product-list-item', {
      key: productId,
      attrs: {
        "product": _vm.getProduct(productId),
        "initialQuantity": 1,
        "extraClasses": "product--card"
      }
    })], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.ready) ? _c('div', [_c('loader')], 1) : _vm._e(), _vm._v(" "), _c('banner')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7becbd3c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductList.vue
// module id = 1199
// module chunks = 0